import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { enqueue } from "../../lib/offlineQueue/queue";
import { listForStation, type ReportCreate, type ReportListItem } from "./api";

export function useCreateReport(stationId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ReportCreate) => enqueue({ endpoint: "POST /reports", body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["reports", stationId] }),
  });
}

export function useReportsForStation(stationId: string | undefined) {
  return useQuery<ReportListItem[]>({
    queryKey: ["reports", stationId ?? ""],
    queryFn: () => listForStation(stationId!),
    enabled: !!stationId,
    staleTime: 15_000,
  });
}
